/**
 *  Layout, i.e. styling specific configuration
 */
export default {
  MOBILE_TABS: {
    SEARCH: 'search',
    LIST: 'list',
    MAP: 'map',
  },
  BREAKPOINTS: {
    TABLET_PORTRAIT: 768,
    TABLET_LANDSCAPE: 1024,
    SMALL_DESKTOP: 1240,
    HD_DESKTOP: 1440,
    XL_DESKTOP: 1880,
  },
  DESKTOP_MEDIA_QUERY: '(min-width: 1024px) and (hover: hover)',
};
